<template>
  <!-- Modal terms -->
  <div
    id="birthdate-information-modal"
    aria-hidden="false"
    aria-labelledby="birthdateInformationModal"
    class="modal fade"
    role="dialog"
    tabindex="-1"
  >
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header">
          <h4 id="birthdateInformationModal" class="modal-title">
            <span class="alert-icon">
              <i class="fa fa-thumbs-o-up"></i>
            </span>
            {{ $t('Doğum tarihimi neden doğru girmeliyim') }}
          </h4>
          <button id="mobileVerifiedModalClose" aria-hidden="true" class="close" data-dismiss="modal" type="button">
            &times;
          </button>
        </div>
        <div class="modal-body modal-body-min">
          <p v-html="$t('Doğum tarihi modal text')"></p>
        </div>
      </div>
      <!-- /.modal-content -->
    </div>
    <!-- /.modal-dialog -->
  </div>
  <!-- /.modal -->
</template>
<script>
export default {
  name: 'birthdateInformationModal',
  data() {
    return {};
  },
  methods: {},
};
</script>
